import { render, staticRenderFns } from "./Admin-layout.vue?vue&type=template&id=5ac6b9ff&scoped=true&lang=pug"
import script from "./Admin-layout.vue?vue&type=script&lang=js"
export * from "./Admin-layout.vue?vue&type=script&lang=js"
import style0 from "./Admin-layout.vue?vue&type=style&index=0&id=5ac6b9ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac6b9ff",
  null
  
)

export default component.exports